import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "d-flex" }
const _hoisted_2 = { class: "settings__content" }

import { computed, ref, watch } from 'vue';
import { storeToRefs } from 'pinia';
import { useI18n } from 'vue-i18n';
import i18n from '@/plugins/i18n';

import { useEditorStore } from '@/store/editor';
import { useCommonStore } from '@/store/common';

import { TTab } from '@/types/TTab';
import { TTabItem } from '@/types/TTabItem';

import AiTabs from '@/components/UI/AiTabs/AiTabs.vue';

import ThemesSettings from '@/components/pages/Generate/ThemesSettings/ThemesSettings.vue';
import PromptSettings from '@/components/pages/Generate/PromptSettings/PromptSettings.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'ProductSettings',
  setup(__props) {

const { t } = useI18n();

const settingsTabs = ref<TTabItem[]>([
  { label: t('editor.settings.theme'), value: 'theme' },
  { label: t('editor.settings.prompt'), value: 'prompt' },
]);

const { generateImageData } = storeToRefs(useEditorStore());
const { isMobile } = storeToRefs(useCommonStore());

const settingsTab = ref<TTab>(generateImageData.value.activeTab);

const lang = computed(() => i18n.global.locale.value);

watch(settingsTab, (newVal) => {
  generateImageData.value.activeTab = newVal;
});

watch(
  () => generateImageData.value.activeTab,
  (newVal) => {
    settingsTab.value = newVal;
  },
);

watch(lang, () => {
  settingsTabs.value = [
    { label: t('editor.settings.theme'), value: 'theme' },
    { label: t('editor.settings.prompt'), value: 'prompt' },
  ];
});

return (_ctx: any,_cache: any) => {
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_window = _resolveComponent("v-window")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["settings", { 'settings--mobile': _unref(isMobile) }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(AiTabs, {
        modelValue: settingsTab.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((settingsTab).value = $event)),
        items: settingsTabs.value
      }, null, 8, ["modelValue", "items"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_window, {
        modelValue: settingsTab.value,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((settingsTab).value = $event)),
        class: "settings__content__list"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_window_item, {
            transition: "transition",
            class: "w-100 settings__content__list__item",
            value: settingsTabs.value[0].value
          }, {
            default: _withCtx(() => [
              _createVNode(ThemesSettings)
            ]),
            _: 1
          }, 8, ["value"]),
          _createVNode(_component_v_window_item, {
            transition: "transition",
            class: "w-100 settings__content__list__item",
            value: settingsTabs.value[1].value
          }, {
            default: _withCtx(() => [
              _createVNode(PromptSettings)
            ]),
            _: 1
          }, 8, ["value"])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ])
  ], 2))
}
}

})